<main>
    <div>
        <app-menu></app-menu>
        <aside>
            <img src="/assets/images/banner-rensa-home-page.png" alt="Rensa training banner" />
            <h4>Home</h4>
            <div>
                <app-button [style]="ButtonType.OUTLINED_PRIMARY" (click)="navigateTo('trainingen')">Bekijk alle trainingen</app-button>&nbsp;&nbsp;
                <app-button [style]="ButtonType.OUTLINED_PRIMARY" (click)="navigateTo('kenniscafe')">Bekijk alle kenniscafés</app-button>
            </div>
        </aside>
    </div>
</main>
<app-footer></app-footer>
